












import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import {
  WidgetMixin,
  EventMixin,
  FieldMixin,
  TextMixin,
  Event,
  Validator,
} from "./mixins";

@Component
export default class WCheckbox extends Mixins(
  WidgetMixin,
  EventMixin,
  FieldMixin,
  TextMixin
) {
  @Prop({ type: [String, Boolean], default: true })
  value!: string | boolean;

  @Prop({ type: Boolean, default: false })
  inline!: boolean;

  @Prop({ type: Boolean, default: false })
  required!: boolean;

  @Prop({ type: Boolean, default: false })
  default!: boolean;

  get isChecked() {
    return this.fieldValue === this.value;
  }

  get computedState() {
    return this.state ? null : this.state;
  }

  changeHandler() {
    this.$nextTick(() => {
      const event = this.isChecked ? "checked" : "unchecked";
      this.broadcastEvents(event);
    });
  }

  @Event("un-check::checkbox")
  uncheck() {
    if (this.isChecked) {
      this.fieldValue = false;
    }
  }

  @Validator("required")
  requiredValidator(value: any) {
    return !!value;
  }

  @Validator("together")
  togetherValidator(value: any, { fields }: { fields: string[] }) {
    const valid = value
      ? fields.map((f) => this.getVariable(f)).every(Boolean)
      : true;
    this.setVariable({
      path: `errors.${this.name}`,
      value: !valid,
    });
    return valid;
  }
}
